/*
  Magalie&Me (Renue Studio, 2026): "Notify me" for sold-out products.
  Buttons with [data-mm-notify] open one shared dialog. The email is sent to Klaviyo's
  Back in Stock API (client endpoint, public company id), so Klaviyo emails the customer
  when the variant is back in stock. Needs "Back in stock" enabled in Klaviyo and a
  Back in Stock flow.
*/
(function () {
  if (window.mmNotifyMe) return;
  window.mmNotifyMe = true;

  var COMPANY_ID = 'VEBEzk';
  var dialog, form, title, status, emailInput, submitBtn, currentVariant;

  var I18N = {
    en: {
      close: 'Close',
      label: 'Back soon',
      text: 'Leave your email and we will let you know as soon as it is back in stock.',
      email: 'Email',
      placeholder: 'Your email',
      submit: 'Notify me',
      legal: 'We only use your email for this notification.',
      privacy: 'Privacy policy',
      invalid: 'Please enter a valid email address.',
      success: 'Thank you. We will email you as soon as it is back.',
      error: 'Something went wrong. Please try again.'
    },
    de: {
      close: 'Schließen',
      label: 'Bald wieder da',
      text: 'Hinterlasse deine E-Mail-Adresse und wir sagen dir Bescheid, sobald es wieder verfügbar ist.',
      email: 'E-Mail',
      placeholder: 'Deine E-Mail-Adresse',
      submit: 'Benachrichtige mich',
      legal: 'Wir verwenden deine E-Mail-Adresse nur für diese Benachrichtigung.',
      privacy: 'Datenschutzerklärung',
      invalid: 'Bitte gib eine gültige E-Mail-Adresse ein.',
      success: 'Danke. Wir schreiben dir, sobald es wieder da ist.',
      error: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.'
    },
    fr: {
      close: 'Fermer',
      label: 'Bientôt de retour',
      text: 'Laissez votre adresse e-mail et nous vous préviendrons dès qu’il sera de nouveau disponible.',
      email: 'E-mail',
      placeholder: 'Votre adresse e-mail',
      submit: 'M’avertir',
      legal: 'Nous utilisons votre adresse e-mail uniquement pour cette notification.',
      privacy: 'Politique de confidentialité',
      invalid: 'Veuillez saisir une adresse e-mail valide.',
      success: 'Merci. Nous vous écrirons dès son retour.',
      error: 'Une erreur s’est produite. Veuillez réessayer.'
    }
  };
  var LANG = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var T = I18N[LANG] || I18N.en;
  var LOCALE_PREFIX = (LANG === 'de' || LANG === 'fr') ? '/' + LANG : '';

  var css = '' +
    '.mm-notify{border:0;padding:0;max-width:440px;width:calc(100% - 40px);background:rgb(var(--background,255 255 255));color:rgb(var(--text-color,26 28 24))}' +
    '.mm-notify::backdrop{background:rgba(13,14,11,.45)}' +
    '.mm-notify__inner{position:relative;padding:36px 32px 30px}' +
    '.mm-notify__close{position:absolute;top:12px;right:12px;width:36px;height:36px;display:grid;place-items:center;background:none;border:0;cursor:pointer;color:inherit;font-size:22px;line-height:1}' +
    '.mm-notify__label{margin:0 0 10px;font-family:var(--subheading-font-family);font-size:11px;letter-spacing:.14em;text-transform:uppercase;opacity:.55}' +
    '.mm-notify__title{margin:0 0 8px;font-family:var(--heading-font-family);font-weight:var(--heading-font-weight);font-size:28px;line-height:1.1;letter-spacing:0;text-transform:none}' +
    '.mm-notify__text{margin:0 0 22px;font-size:14px;line-height:1.5;opacity:.65}' +
    '.mm-notify__input{width:100%;height:48px;padding:0 14px;border:1px solid rgb(var(--text-color,26 28 24) / .3);border-radius:0;background:transparent;color:inherit;font:inherit;font-size:15px}' +
    '.mm-notify__input:focus{outline:none;border-color:rgb(var(--text-color,26 28 24))}' +
    '.mm-notify__submit{width:100%;height:48px;margin-top:10px;border:1px solid rgb(var(--text-color,26 28 24));background:rgb(var(--text-color,26 28 24));color:rgb(var(--background,255 255 255));font-family:var(--text-font-family);font-size:13px;letter-spacing:.1em;text-transform:uppercase;cursor:pointer;transition:background .25s,color .25s}' +
    '@media (pointer:fine){.mm-notify__submit:hover{background:transparent;color:rgb(var(--text-color,26 28 24))}}' +
    '.mm-notify__submit[disabled]{opacity:.6;cursor:default}' +
    '.mm-notify__legal{margin:14px 0 0;font-size:12px;line-height:1.5;opacity:.55}' +
    '.mm-notify__legal a{color:inherit;text-decoration:underline}' +
    '.mm-notify__status{margin:12px 0 0;font-size:14px;line-height:1.5}' +
    '.mm-notify__status--error{color:#b3261e}';

  function build() {
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    dialog = document.createElement('dialog');
    dialog.className = 'mm-notify';
    dialog.setAttribute('aria-labelledby', 'mm-notify-title');
    dialog.innerHTML =
      '<div class="mm-notify__inner">' +
        '<button type="button" class="mm-notify__close" aria-label="' + T.close + '">&times;</button>' +
        '<p class="mm-notify__label">' + T.label + '</p>' +
        '<h2 class="mm-notify__title" id="mm-notify-title"></h2>' +
        '<p class="mm-notify__text">' + T.text + '</p>' +
        '<form class="mm-notify__form" novalidate>' +
          '<label class="sr-only" for="mm-notify-email">' + T.email + '</label>' +
          '<input class="mm-notify__input" id="mm-notify-email" type="email" name="email" autocomplete="email" placeholder="' + T.placeholder + '" required>' +
          '<button class="mm-notify__submit" type="submit">' + T.submit + '</button>' +
          '<p class="mm-notify__legal">' + T.legal + ' <a href="' + LOCALE_PREFIX + '/policies/privacy-policy">' + T.privacy + '</a></p>' +
          '<p class="mm-notify__status" role="status" aria-live="polite"></p>' +
        '</form>' +
      '</div>';
    document.body.appendChild(dialog);

    form = dialog.querySelector('form');
    title = dialog.querySelector('.mm-notify__title');
    status = dialog.querySelector('.mm-notify__status');
    emailInput = dialog.querySelector('input');
    submitBtn = dialog.querySelector('.mm-notify__submit');

    dialog.querySelector('.mm-notify__close').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setStatus(T.invalid, true);
        emailInput.focus();
        return;
      }
      submitBtn.disabled = true;
      setStatus('', false);

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              channels: ['EMAIL']
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + currentVariant } }
            }
          }
        })
      }).then(function (res) {
        if (!res.ok) throw new Error(res.status);
        form.reset();
        setStatus(T.success, false);
      }).catch(function () {
        setStatus(T.error, true);
      }).finally(function () {
        submitBtn.disabled = false;
      });
    });
  }

  function setStatus(msg, isError) {
    status.textContent = msg;
    status.classList.toggle('mm-notify__status--error', !!isError);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mm-notify]');
    if (!btn) return;
    e.preventDefault();
    if (!dialog) build();
    currentVariant = btn.getAttribute('data-variant-id');
    title.textContent = btn.getAttribute('data-product-title') || '';
    setStatus('', false);
    dialog.showModal();
    setTimeout(function () { emailInput.focus(); }, 50);
  });
})();
